import React, { useEffect, useState } from "react";
import combinedServices from "../../../shared/services/user-service";
import swal from "sweetalert";
import getRemoveData from "../../../shared/localStorage/removeData";
import "./RaceAdministratorList.scss";

function RaceClubOfficerList({
  raceClubOfficerList,
  club_id,
  showraceClubOfficerResponsive,
  setShowraceClubOfficerResponsive,
  refreshClubOfficers,
}) {
  const [searchUser, setSearchUser] = useState("");
  const [inputbox, setInputbox] = useState(false);
  const [subMember, setSubMember] = useState([]);
  const [raceClubOfficers, setRaceClubOfficers] = useState([]);

  // Sync raceClubOfficerList prop to local state
  useEffect(() => {
    setRaceClubOfficers(raceClubOfficerList);
  }, [raceClubOfficerList]);

  // Fetch users for the search box
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        let eventSubMember =
          await combinedServices.getAllUserForManageEntries();
        if (eventSubMember.status === 401) {
          swal(eventSubMember.msg, "Please Re-login", "warning").then(() => {
            getRemoveData("user_info");
            localStorage.clear();
            window.location.href = "/login";
          });
        }
        if (eventSubMember.status === 200) {
          const userList = eventSubMember.data
            .filter((user) => user.user_status === "active")
            .map((user) => ({
              name: `${user.user_firstname} ${user.user_lastname}`,
              id: user.id,
            }));
          setSubMember(userList);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, []);

  // Handle delete race club officer
  const handleDeleteRaceClubOfficer = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this officer!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const res = await combinedServices.deleteRaceClubOfficer(id);
          if (res.status === 200) {
            swal(
              "Deleted!",
              "Race Club Officer removed successfully.",
              "success"
            );
            setRaceClubOfficers(
              raceClubOfficers.filter((officer) => officer.id !== id)
            );
          } else {
            swal("Error", res.msg || "Failed to remove officer", "error");
          }
        } catch (error) {
          console.error("Error removing race club officer:", error);
          swal("Error", "Something went wrong. Please try again.", "error");
        }
      }
    });
  };

  // Handle search box input
  const handleSearchBox = (e) => {
    setSearchUser(e.target.value);
    setInputbox(e.target.value !== "");
  };

  // Handle adding a new race club officer
  const handleSubUser = async (user) => {
    setInputbox(false);
    document.getElementById("searchUser").value = user.name;
    try {
      const response = await combinedServices.createRaceClubOfficer({
        user_id: user.id,
        club_id: club_id,
      });
      if (response.status === 200 || response.status === 201) {
        swal("Success", "Race Club Officer added successfully!", "success");
        await refreshClubOfficers(); // ✅ Fetch fresh data instead of local update
      } else {
        swal("Error", response.msg || "Failed to add officer", "error");
      }
    } catch (error) {
      console.error("Error adding race club officer:", error);
      swal("Error", "Something went wrong. Please try again.", "error");
    }
  };

  return (
    <div
      className={`myRace raceadministrator ${showraceClubOfficerResponsive}`}
    >
      <div className="userName member" style={{ width: "100%" }}>
        <div className="myRaceHd" style={{ padding: "20px 0" }}>
          Manage Race Administrators
          <span
            onClick={() => {
              setShowraceClubOfficerResponsive("");
            }}
            className="nav-control closeBtn"
          >
            <span className="material-icons" translate="no">
              close
            </span>
          </span>
        </div>
        <div className="flexBox nowrap itemCenter districtSelectBox">
          <div className="eventInner searchBox membersList-box">
            <input
              type="text"
              className="searchUser"
              id="searchUser"
              placeholder="search user"
              onChange={handleSearchBox}
              autoComplete="off"
            />
            {inputbox && (
              <ul className="flexBox eventForm" id="toggleText">
                {subMember
                  .filter(
                    (val) =>
                      searchUser === "" ||
                      val.name.toLowerCase().includes(searchUser.toLowerCase())
                  )
                  .map((user) => (
                    <li
                      key={user.id}
                      onClick={() => {
                        handleSubUser(user);
                      }}
                    >
                      {user.name}
                    </li>
                  ))}
              </ul>
            )}
          </div>
        </div>
        <React.Fragment>
          <ul className="memberList" style={{ display: "contents" }}>
            {raceClubOfficers?.length > 0 ? (
              raceClubOfficers.map((item) => (
                <li key={item?.user?.id}>
                  <a className="flexBox nowrap itemCenter spacebetween">
                    <span className="name">
                      {`${item?.user?.user_firstname} ${item?.user?.user_lastname}` ||
                        ""}
                    </span>
                    <div className="d-flex align-items-center">
                      <span className="count me-2">{item?.user?.id}</span>
                      <button className="entriesButton">
                        <span
                          className="material-icons-outlined"
                          onClick={() => handleDeleteRaceClubOfficer(item.id)}
                          translate="no"
                        >
                          delete
                        </span>
                      </button>
                    </div>
                  </a>
                </li>
              ))
            ) : (
              <span>No Manage Race Administrators</span>
            )}
          </ul>
        </React.Fragment>
      </div>
    </div>
  );
}

export default RaceClubOfficerList;
